import axios from "../../axios/axios";
import { Kontakt } from "../../ts/Kontakt";
import { Obrat } from "../../ts/Obraty";
import {
  IGenericResponse,
  ILazyResultResponse,
} from "../../types/server-api/common";
import {
  TCreateObratBody,
  TEditObratBody,
  TExportObratyQuery,
  TGetFilteredObratyQuery,
} from "../../types/server-api/obrat";

import { APIRoutes } from "../server-api/routes";

export type TObratGroup = {
  _id: string;
  id_klienta: Kontakt["id_klienta"];
  rok: number;
  suma_1: number;
  suma_2: number;
  suma_3: number;
  suma_4: number;
  suma_5: number;
  suma_6: number;
  suma_7: number;
  suma_8: number;
  suma_9: number;
  suma_10: number;
  suma_11: number;
  suma_12: number;
  suma_celkem_za_rok: number;
  suma_celkem_za_mesiace: number;
  kontakt: Kontakt;
};

export interface IObratModel {
  getFilteredObraty(
    query: TGetFilteredObratyQuery
  ): Promise<ILazyResultResponse<Obrat[]>>;
  getFilteredObratyGroups(
    query: TGetFilteredObratyQuery
  ): Promise<ILazyResultResponse<TObratGroup[]>>;
  editObrat(body: TEditObratBody): Promise<IGenericResponse>;
  createObrat(body: TCreateObratBody): Promise<Obrat>;
  deleteObrat(body: { _id: string }): Promise<IGenericResponse>;
  exportObraty(body: TExportObratyQuery): Promise<Blob>;
}

export const obratModel: IObratModel = {
  getFilteredObraty: async (params) => {
    const res = await axios.get<ILazyResultResponse<Obrat[]>>(
      APIRoutes.Obrat.GetFiltered,
      {
        params,
      }
    );

    return res.data;
  },
  getFilteredObratyGroups: async (params) => {
    const res = await axios.get<ILazyResultResponse<TObratGroup[]>>(
      APIRoutes.Obrat.GetFilteredGroups,
      {
        params,
      }
    );

    return res.data;
  },
  editObrat: async (data) => {
    const res = await axios.post<IGenericResponse>(APIRoutes.Obrat.Edit, data);

    return res.data;
  },
  createObrat: async (data) => {
    const res = await axios.post<Obrat>(APIRoutes.Obrat.Create, data);

    return res.data;
  },
  deleteObrat: async (data) => {
    const res = await axios.post<IGenericResponse>(APIRoutes.Obrat.Delete, {
      id: data._id,
    });

    return res.data;
  },
  exportObraty: async (data) => {
    const res = await axios.post<Blob>(APIRoutes.Obrat.Export, data, {
      responseType: "blob",
    });

    return res.data;
  },
};
